import styles from "./Trivia.module.css";
import { useCallback, useEffect, useState } from "react";
import Choice from "../components/Choice";
import supabase from "../supabaseClient";

const Trivia = ({
  question,
  choices,
  question_id,
  info,
  athlete=''
}) => {

  const [percentages, setPercentages] = useState();

  useEffect(() => {
    getCount();
  }, []);

  const [selectedAnswer, setSelectedAnswer] = useState();

  const createResponse = async (choice) => {
    const { error } = await supabase
      .from('responses')
      .insert({ question_id: question_id, choice: choice })
  }

  const getCount = async () => {
    const { data, error } = await supabase.rpc('count_response', { question: question_id })

    const total = data.reduce((sum, e) => sum + e.count, 0)
    let h = {}

    data.forEach((a) => {
      h[a.choice] = Math.round((a.count / total) * 100)
    })

    h[3] = 100 - (h[0] || 0)  - (h[1] || 0) - (h[2] || 0)

    setPercentages(h);
  }


  const onChoiceClick = (choice) => {
    umami?.track('Interaction - ' + athlete  + ' Trivia');

    createResponse(choice)
    setSelectedAnswer(choice)
  }

  const message = () => {
    if (selectedAnswer == undefined) return question

    if (choices[selectedAnswer].correct) {
      return "Correct."
    } else {
      return "Nope."
    }
  }

  return (
    <div className={styles.triviaParent}>
      <div className={styles.question}>
        <p className={styles.correctIncorrect}> { message() } </p>
        { selectedAnswer !== undefined && <p className={styles.infoMessage}> { info } </p> }
      </div>
      {
        choices.map((choice, i) => {
          return (
            <Choice key={i} choice={choice} percent={(percentages || {})[String(i)]} onClick={() => { onChoiceClick(i) } } clicked={selectedAnswer !== undefined} />
          );
        })
      }
    </div>
  );
};

export default Trivia;
